import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@env/environment';
import {DistrictCardReader} from './district-card-readers.model';
import {lastValueFrom} from 'rxjs';
import {GenericService} from "@ui-kit/framework/common/generic.service";

@Injectable({
  providedIn: 'root'
})


export class DistrictCardReadersService extends GenericService<DistrictCardReader> {


  constructor(http: HttpClient) {
    super(http, environment.apiDistrictsHost + `/console/districts`);
  }

  public saveNew(cardReader: DistrictCardReader): Promise<boolean> {
    const uri = `${this.baseUrl}/${cardReader.districtUuid}/card-reader`;

    return lastValueFrom(this.http.post(uri, cardReader))
      .then(() => {
        console.log("successfully created");
        return Promise.resolve(true);
      })
      .catch((error: string) => {
        console.error("failed to create card reader: ", error);
        return Promise.resolve(false);
      })
  }

  public remove(districtUuid: string, cardReaderUuid: string): void {

    const uri = `${this.baseUrl}/${districtUuid}/card-reader/${cardReaderUuid}`;
    lastValueFrom(this.http.delete(uri))
      .then(() => {
        console.log('successfully deleted:', cardReaderUuid);
      })
      .catch((error: string) => {
        console.log(`error deleting ${cardReaderUuid}: `, error);
      })
  }
}




